import { useLanguage } from '../context/LanguageContext';

// Brand logos - unique only
const brandLogos = [
  { name: 'Abbott', logo: 'https://customer-assets.emergentagent.com/job_64e1d9dc-aa4a-4c60-baa6-8818ce7cb16b/artifacts/bapiei4b_Abbott_Laboratories_logo.svg.png' },
  { name: 'AstraZeneca', logo: 'https://customer-assets.emergentagent.com/job_64e1d9dc-aa4a-4c60-baa6-8818ce7cb16b/artifacts/wpbuq8ce_astrazeneca-logo-png-astrazeneca-logo-astra-zeneca-4902.png' },
  { name: 'Ferring', logo: 'https://customer-assets.emergentagent.com/job_64e1d9dc-aa4a-4c60-baa6-8818ce7cb16b/artifacts/bru3jtur_FERRING_Logo_RGB-R0-G136-B206.png' },
  { name: 'Baxter', logo: 'https://customer-assets.emergentagent.com/job_4c33b93d-22ff-46d7-a5ee-41ef8de79233/artifacts/7y85iq63_Baxter.svg.png' },
  { name: 'Bayer', logo: 'https://customer-assets.emergentagent.com/job_4c33b93d-22ff-46d7-a5ee-41ef8de79233/artifacts/jo03z9xl_Bayer-Logo.wine.png' },
  { name: 'Chicco', logo: 'https://customer-assets.emergentagent.com/job_4c33b93d-22ff-46d7-a5ee-41ef8de79233/artifacts/t7gocyg5_Chicco_logo.svg.png' },
  { name: 'Philips', logo: 'https://customer-assets.emergentagent.com/job_4c33b93d-22ff-46d7-a5ee-41ef8de79233/artifacts/3v83krvq_Philips_logo.svg.png' },
  { name: 'Unilever', logo: 'https://customer-assets.emergentagent.com/job_4c33b93d-22ff-46d7-a5ee-41ef8de79233/artifacts/rj56k0iw_Unilever.svg.png' },
  { name: 'Roche', logo: 'https://customer-assets.emergentagent.com/job_4c33b93d-22ff-46d7-a5ee-41ef8de79233/artifacts/84mtyeko_logo.svg' },
];

export const BrandsMarquee = () => {
  const { t, isArabic } = useLanguage();

  return (
    <section className="py-16 md:py-20 bg-white relative" data-testid="brands-section">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10">
          <span className="text-xs uppercase tracking-widest text-slate-500 mb-3 block">
            {t('trustedBrands')}
          </span>
          <h2 className={`text-2xl md:text-3xl font-bold text-slate-900 ${isArabic ? 'font-arabic' : 'font-english'}`}>
            {t('ourPartners')}
          </h2>
        </div>

        {/* Static centered logos */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {brandLogos.map((brand, index) => (
            <div
              key={index}
              className="w-40 h-24 md:w-52 md:h-28 flex items-center justify-center p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-slate-100"
            >
              <img
                src={brand.logo}
                alt={brand.name}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsMarquee;
